/* istanbul ignore file */

export const debounce = (fn: any, delay: number): any => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};

export const smoothScrollTo = (
  containerRef: React.RefObject<HTMLDivElement>,
  targetScrollX: number,
  duration: number
): void => {
  if (!containerRef.current) return;

  const startScrollX = containerRef.current.scrollLeft;
  const startTime = performance.now();

  const scrollStep = (timestamp: number): void => {
    const currentTime = timestamp - startTime;
    if (currentTime < duration) {
      const scrollX = easeInOutQuad(
        currentTime,
        startScrollX,
        targetScrollX - startScrollX,
        duration
      );
      if (containerRef.current) {
        containerRef.current.scrollLeft = scrollX;
      }
      requestAnimationFrame(scrollStep);
    } else {
      if (containerRef.current) {
        containerRef.current.scrollLeft = targetScrollX;
      }
    }
  };

  const easeInOutQuad = (
    t: number,
    b: number,
    c: number,
    d: number
  ): number => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(scrollStep);
};
